import { AgenturNameCell } from 'app/components/shared/AgenturName.cell';
import { Table } from 'app/components/table/table';
import { AggregrationType, ITableColumn, TableModel } from 'app/components/table/table.model';
import { useStore } from 'app/context';
import { observer } from 'mobx-react';
import { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router';
import _ from 'lodash';
import { WkzgKofferVM } from 'app/stores/ui/agt.wkzgkoffer.ui.store';
import { formatNumTwoDig } from 'app/utils';


interface IWerkzeugkofferFzwListe {
	year: number;
}

export const WerkzeugkofferFzwListe = observer((props: IWerkzeugkofferFzwListe) => {
	const { berichteUiiStore, agtWkzkofferUiStore, agenturListUiStore } = useStore();
	const history = useHistory();
	const [hasItems, setHasItems] = useState(false);

	const tm = useMemo(() => {
		const tm = new TableModel<WkzgKofferVM, number>();
		const cols: ITableColumn<WkzgKofferVM, number>[] = [];

		cols.push({
			label: 'Agentur',
			path: 'agt.name',
			sortBy: 'agt.name',
			render: AgenturNameCell,
		});
		cols.push({
			label: 'Neu- Kaufpreisentschädigung',
			path: 'fzw.neuKaufpreisentschaedigung',
			agg: [
				{
					aggType: AggregrationType.sum,
				},
				{
					aggType: AggregrationType.avg,
					format: formatNumTwoDig,
				},
			],
		});
		cols.push({
			label: 'SB Verzicht',
			path: 'fzw.sbVerzicht',
			agg: [
				{
					aggType: AggregrationType.sum,
				},
				{
					aggType: AggregrationType.avg,
					format: formatNumTwoDig,
				},
			],
		});
		cols.push({
			label: 'Wertgutschein',
			path: 'fzw.wertgutschein',
			agg: [
				{
					aggType: AggregrationType.sum,
				},
				{
					aggType: AggregrationType.avg,
					format: formatNumTwoDig,
				},
			],
		});
		if (props.year >= 2026) {

			cols.push({
				label: '24 Monate Preisgarantie',
				path: 'fzw.preisgarant24Monate',
				agg: [
					{
						aggType: AggregrationType.sum,
					},
					{
						aggType: AggregrationType.avg,
						format: formatNumTwoDig,
					},
				],
			});
		}

		tm.sortBy = 'agt.name';
		tm.setCols(cols);

		tm.idProperty = 'agtId';
		tm.idType = 'number';

		return tm;
	}, []);

	useEffect(() => {
		agtWkzkofferUiStore.load().then(() => {
			let items = agtWkzkofferUiStore.items;
			items = items.filter(x => x.year === props.year);
			// filter only agt with fzw
			items = items.filter((i) => i.fzw.hasWkzg);

			if (berichteUiiStore.selectedAgt) {
				const agtId = berichteUiiStore.selectedAgt.agtId;
				items = items.filter((i) => i.agt.agtId === agtId);
			} else {
				items = agenturListUiStore.applyFilterOnAgt(items) as WkzgKofferVM[];
			}
			setHasItems(items.length > 0);
			tm.setRowData(items);
			tm.sort();
		});
	}, [tm, berichteUiiStore.selectedAgt, agenturListUiStore.filterHasChanged, agenturListUiStore, agtWkzkofferUiStore.items, agtWkzkofferUiStore]);

	return (
		<>
			<div className="table-container pad-bottom-3rem">
				{!hasItems ? (
					<div className="pad-1rem">Keine Werkzeugkoffer Teilnahme</div>
				) : (
					<>
						<Table stickyHeader={true} tm={tm}></Table>
					</>
				)}
			</div>
		</>
	);
});
